import {
  ActionButtonProps,
  Box,
  ColorOptions,
  Form,
  Icon,
  Loader,
  ModBox,
  SpacerNew,
  Text,
  allThemes,
} from '@jfs/ui-new'
import { useRef, useState } from 'react'
import { RootStore } from '../../../data/store'
import { MessageTypes } from '../../../utils'
import { SelectParentEntityList } from '../Onboarding/CreateEntity/SelectParentEntityList'
import { styles } from '../styles'
import {
  AuthorisedForm,
  DirectorForm,
  UboForm,
  authorizedEditListColumnFlex,
  authorizedEditListTitles,
  authorizedListColumnFlex,
  authorizedListTitles,
  directorEditListColumnFlex,
  directorEditListTitles,
  directorListColumnFlex,
  directorListTitles,
  uboEditListColumnFlex,
  uboEditListTitles,
  uboListColumnFlex,
  uboListTitles,
} from './formData'

const FormBoxFull = ({ children }: any) => {
  return <Box w={'100%'}>{children}</Box>
}

const TableWithEditAddForm = ({
  type,
  addChanges,
  updateChanges,
  deleteRow,
  listData,
  onSubmitPress,
  apiHandler,
  editedData,
  identificationNumber,
  undoChanges,
}: any) => {
  const dirRef = useRef(null)
  const authRef = useRef(null)
  const uboRef = useRef(null)
  const [isEditPressed, setEditPressed] = useState(false)
  const [isBeginSet, setBeginSet] = useState(false)
  const [beginDate, setBeginDate] = useState(undefined)
  const [itemData, setItemData] = useState(
    type === 'director'
      ? {
          din: '',
          firstName: '',
          middleName: '',
          lastName: '',
          dob: '',
          beginAt: '',
          endAt: '',
          action: '',
          directorReferenceId: '',
        }
      : type === 'ubo'
      ? {
          firstName: '',
          middleName: '',
          lastName: '',
          dob: '',
          action: '',
          beneficialOwnerReferenceId: '',
        }
      : {
          firstName: '',
          middleName: '',
          lastName: '',
          dob: '',
          action: '',
          authorisedSignatoryReferenceId: '',
        },
  )

  const handleClearPress = () => {
    setEditPressed(false)
    setBeginSet(false)
    setItemData(
      type === 'director'
        ? {
            beginAt: '',
            din: '',
            dob: '',
            endAt: '',
            firstName: '',
            middleName: '',
            lastName: '',
            directorReferenceId: '',
            action: '',
          }
        : type === 'ubo'
        ? {
            firstName: '',
            middleName: '',
            lastName: '',
            dob: '',
            beneficialOwnerReferenceId: '',
            action: '',
          }
        : {
            firstName: '',
            middleName: '',
            lastName: '',
            dob: '',
            authorisedSignatoryReferenceId: '',
            action: '',
          },
    )
    try {
      if (type === 'director' && dirRef && dirRef.current) {
        dirRef?.current({
          beginAt: '',
          din: '',
          dob: '',
          endAt: '',
          firstName: '',
          middleName: '',
          lastName: '',
          directorReferenceId: '',
        })
      }
      if (type === 'ubo' && uboRef && uboRef.current) {
        uboRef?.current({
          uboFname: '',
          uboMname: '',
          uboLname: '',
          uboDob: '',
          action: '',
          beneficialOwnerReferenceId: '',
        })
      }
      if (type === 'auth' && authRef && authRef.current) {
        authRef?.current({
          authSigFirstname: '',
          authSigMidname: '',
          authSigLastname: '',
          authSigDOB: '',
          action: '',
          authorisedSignatoryReferenceId: '',
        })
      }
    } catch (e) {
      console.log('TableWithEditAddForm handleClearPress Error: ', e)
    }
    setBeginSet(false)
  }

  const onEditPress = (rowData: any) => {
    setEditPressed(true)
    setItemData(
      type === 'director'
        ? {
            din: rowData?.din,
            firstName: rowData?.firstName,
            middleName: rowData?.middleName ?? '',
            lastName: rowData?.lastName,
            dob: rowData?.dob,
            beginAt: rowData?.beginAt,
            endAt: rowData?.endAt,
            directorReferenceId: rowData?.directorReferenceId,
            action: rowData?.action,
          }
        : type === 'ubo'
        ? {
            firstName: rowData?.firstName,
            middleName: rowData?.middleName ?? '',
            lastName: rowData?.lastName,
            dob: !isNaN(rowData?.dob) ? new Date(rowData?.dob).toISOString() : rowData?.dob,
            beneficialOwnerReferenceId: rowData?.beneficialOwnerReferenceId,
            action: rowData?.action,
          }
        : {
            firstName: rowData?.firstName,
            middleName: rowData?.middleName ?? '',
            lastName: rowData?.lastName,
            dob: rowData?.dob,
            authorisedSignatoryReferenceId: rowData?.authorisedSignatoryReferenceId,
            action: rowData?.action,
          },
    )
  }

  const handleSubmitPress = () => {
    onSubmitPress()
    if (editedData?.length > 0) {
      handleClearPress()
    } else {
      RootStore.message.setMessage('No changes to submit', MessageTypes.INFO)
    }
  }
  const onListDeleteRow = (rowData: any) => {
    setEditPressed(false)
    deleteRow && deleteRow(rowData, identificationNumber)
  }

  const handleDirectorActions = ({ values, isValid, isCurrentFormValid, resetForm }: ActionButtonProps) => {
    dirRef.current = resetForm

    let isDirFormChanged = false
    const firstName = itemData?.firstName
    const middleName = itemData?.middleName
    const lastName = itemData?.lastName
    const dob = itemData?.dob
    const beginAt = itemData?.beginAt
    const endAt = itemData?.endAt

    if (isEditPressed) {
      isDirFormChanged =
        firstName !== values?.firstName ||
        middleName !== values?.middleName ||
        lastName !== values?.lastName ||
        dob !== values?.dob ||
        beginAt !== values?.beginAt ||
        endAt !== values?.endAt
    } else {
      isDirFormChanged = isCurrentFormValid
    }

    const handleAddPress = () => {
      addChanges(values)
      handleClearPress()
    }

    const handleUpdatePress = () => {
      updateChanges(values, identificationNumber)
      handleClearPress()
    }

    if (values?.beginAt?.length > 0 && !isBeginSet) {
      setBeginSet(true)
      setBeginDate(values?.beginAt)
    }

    return (
      <ModBox w={'100%'} justifyContent={'center'} alignItems={'center'}>
        <ModBox w={'100%'} justifyContent={'center'} alignItems={'center'} direction="row">
          <Box
            {...styles.buttonBgView}
            disabled={!isDirFormChanged}
            w={100}
            backgroundColor={
              isDirFormChanged ? ('PRIMARY' as ColorOptions) : (allThemes.light.colors.DISABLED_GREY as ColorOptions)
            }
            onPress={isEditPressed ? handleUpdatePress : handleAddPress}>
            {false ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text
                color={
                  isDirFormChanged
                    ? (allThemes.light.colors.WHITE as ColorOptions)
                    : (allThemes.light.colors.GRAY_LIGHT as ColorOptions)
                }
                type="body2">
                {isEditPressed ? 'Update' : 'Add'}
              </Text>
            )}
          </Box>
          <Box
            {...styles.buttonBgView}
            w={100}
            marginHorizontal={16}
            backgroundColor={'PRIMARY' as ColorOptions}
            onPress={handleClearPress}>
            {false ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text color={allThemes.light.colors.WHITE as ColorOptions} type="body2">
                {'Clear'}
              </Text>
            )}
          </Box>
          <Box
            {...styles.buttonBgView}
            disabled={!(editedData?.length > 0 && type === 'director')}
            w={100}
            backgroundColor={
              editedData?.length > 0 && type === 'director'
                ? ('PRIMARY' as ColorOptions)
                : (allThemes.light.colors.DISABLED_GREY as ColorOptions)
            }
            onPress={handleSubmitPress}>
            {apiHandler?.state === 'pending' ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text
                color={
                  editedData?.length > 0 && type === 'director'
                    ? (allThemes.light.colors.WHITE as ColorOptions)
                    : (allThemes.light.colors.GRAY_LIGHT as ColorOptions)
                }
                type="body2">
                {'Submit'}
              </Text>
            )}
          </Box>
        </ModBox>
      </ModBox>
    )
  }

  const handleUboActions = ({ values, isCurrentFormValid, resetForm }: ActionButtonProps) => {
    uboRef.current = resetForm

    let isUboFormChanged = false
    const uboFname = itemData?.firstName
    const uboMname = itemData?.middleName
    const uboLname = itemData?.lastName
    const uboDob = itemData?.dob
    if (isEditPressed) {
      isUboFormChanged =
        uboFname !== values?.uboFname ||
        uboMname !== values?.uboMname ||
        uboLname !== values?.uboLname ||
        uboDob !== values?.uboDob
    } else {
      isUboFormChanged = isCurrentFormValid
    }

    const handleAddPress = () => {
      addChanges(values)
      handleClearPress()
    }

    const handleUpdatePress = () => {
      updateChanges(values, identificationNumber)
      handleClearPress()
    }
    return (
      <ModBox w={'100%'} justifyContent={'center'} alignItems={'center'}>
        <ModBox w={'100%'} justifyContent={'center'} alignItems={'center'} direction="row">
          <Box
            {...styles.buttonBgView}
            disabled={!isUboFormChanged}
            w={100}
            backgroundColor={
              isUboFormChanged ? ('PRIMARY' as ColorOptions) : (allThemes.light.colors.DISABLED_GREY as ColorOptions)
            }
            onPress={isEditPressed ? handleUpdatePress : handleAddPress}>
            {false ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text
                color={
                  isUboFormChanged
                    ? (allThemes.light.colors.WHITE as ColorOptions)
                    : (allThemes.light.colors.GRAY_LIGHT as ColorOptions)
                }
                type="body2">
                {isEditPressed ? 'Update' : 'Add'}
              </Text>
            )}
          </Box>
          <Box
            {...styles.buttonBgView}
            w={100}
            marginHorizontal={16}
            backgroundColor={'PRIMARY' as ColorOptions}
            onPress={handleClearPress}>
            {false ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text color={allThemes.light.colors.WHITE as ColorOptions} type="body2">
                {'Clear'}
              </Text>
            )}
          </Box>
          <Box
            {...styles.buttonBgView}
            disabled={!(editedData?.length > 0 && type === 'ubo')}
            w={100}
            backgroundColor={
              editedData?.length > 0 && type === 'ubo'
                ? ('PRIMARY' as ColorOptions)
                : (allThemes.light.colors.DISABLED_GREY as ColorOptions)
            }
            onPress={handleSubmitPress}>
            {apiHandler?.state === 'pending' ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text
                color={
                  editedData?.length > 0 && type === 'ubo'
                    ? (allThemes.light.colors.WHITE as ColorOptions)
                    : (allThemes.light.colors.GRAY_LIGHT as ColorOptions)
                }
                type="body2">
                {'Submit'}
              </Text>
            )}
          </Box>
        </ModBox>
      </ModBox>
    )
  }

  const handleAuthActions = ({ values, isCurrentFormValid, resetForm }: ActionButtonProps) => {
    authRef.current = resetForm

    let authSigFormChanged = false
    const authFname = itemData?.firstName
    const authMname = itemData?.middleName
    const authLname = itemData?.lastName
    const authDob = itemData?.dob
    if (isEditPressed) {
      authSigFormChanged =
        authFname !== values?.authSigFirstname ||
        authMname !== values?.authSigMidname ||
        authLname !== values?.authSigLastname ||
        authDob !== values?.authSigDOB
    } else {
      authSigFormChanged = isCurrentFormValid
    }
    const handleAddPress = () => {
      addChanges(values)
      handleClearPress()
    }

    const handleUpdatePress = () => {
      updateChanges(values, identificationNumber)
      handleClearPress()
    }

    return (
      <ModBox w={'100%'} justifyContent={'center'} alignItems={'center'}>
        <ModBox w={'100%'} justifyContent={'center'} alignItems={'center'} direction="row">
          <Box
            {...styles.buttonBgView}
            disabled={!authSigFormChanged}
            w={100}
            backgroundColor={
              authSigFormChanged ? ('PRIMARY' as ColorOptions) : (allThemes.light.colors.DISABLED_GREY as ColorOptions)
            }
            onPress={isEditPressed ? handleUpdatePress : handleAddPress}>
            {false ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text
                color={
                  authSigFormChanged
                    ? (allThemes.light.colors.WHITE as ColorOptions)
                    : (allThemes.light.colors.GRAY_LIGHT as ColorOptions)
                }
                type="body2">
                {isEditPressed ? 'Update' : 'Add'}
              </Text>
            )}
          </Box>
          <Box
            {...styles.buttonBgView}
            w={100}
            marginHorizontal={16}
            backgroundColor={'PRIMARY' as ColorOptions}
            onPress={handleClearPress}>
            {false ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text color={allThemes.light.colors.WHITE as ColorOptions} type="body2">
                {'Clear'}
              </Text>
            )}
          </Box>
          <Box
            {...styles.buttonBgView}
            disabled={!(editedData?.length > 0 && type === 'auth')}
            w={100}
            backgroundColor={
              editedData?.length > 0 && type === 'auth'
                ? ('PRIMARY' as ColorOptions)
                : (allThemes.light.colors.DISABLED_GREY as ColorOptions)
            }
            onPress={handleSubmitPress}>
            {apiHandler?.state === 'pending' ? (
              <Loader type="small" color="WHITE" />
            ) : (
              <Text
                color={
                  editedData?.length > 0 && type === 'auth'
                    ? (allThemes.light.colors.WHITE as ColorOptions)
                    : (allThemes.light.colors.GRAY_LIGHT as ColorOptions)
                }
                type="body2">
                {'Submit'}
              </Text>
            )}
          </Box>
        </ModBox>
      </ModBox>
    )
  }

  const onUndo = (item: any) => {
    console.log('onUndo item =>', item)
    undoChanges(item, identificationNumber)
  }

  return (
    <ModBox marginHorizontal={32} marginVertical={32}>
      <ModBox>
        <ModBox
          alignItems={'center'}
          justifyContent={'center'}
          borderBottomWidth={1}
          borderStyle={'dashed'}
          paddingBottom={8}>
          <Text
            title={
              type === 'director'
                ? 'Director Details'
                : type === 'ubo'
                ? 'Ultimate Beneficiary Owner Details'
                : 'Authorised signatory Details'
            }
            color={'BLACK_21'}
            fontSize={14}
            fontFamily={'jiotype-bold'}
          />
        </ModBox>
        <ModBox show={listData?.length > 0} mt={16}>
          <SelectParentEntityList
            title={''}
            hide={false}
            data={listData}
            headerTitles={
              type === 'director' ? directorListTitles : type === 'ubo' ? uboListTitles : authorizedListTitles
            }
            columnFlexMapper={
              type === 'director'
                ? directorListColumnFlex
                : type === 'ubo'
                ? uboListColumnFlex
                : authorizedListColumnFlex
            }
            onDelete={onListDeleteRow}
            onEditPress={onEditPress}
          />
        </ModBox>
        <ModBox show={editedData?.length > 0} mt={16}>
          <Text
            title={
              type === 'director'
                ? 'Updated Director Details'
                : type === 'ubo'
                ? 'Updated Ultimate Beneficiary Owner Details'
                : 'Updated Authorised signatory Details'
            }
            color={'BLACK_21'}
            fontSize={14}
            fontFamily={'jiotype-bold'}
          />
          <SpacerNew size={16} />
          <SelectParentEntityList
            title={''}
            hide={false}
            data={editedData}
            headerTitles={
              type === 'director'
                ? directorEditListTitles
                : type === 'ubo'
                ? uboEditListTitles
                : authorizedEditListTitles
            }
            columnFlexMapper={
              type === 'director'
                ? directorEditListColumnFlex
                : type === 'ubo'
                ? uboEditListColumnFlex
                : authorizedEditListColumnFlex
            }
            onUndoPress={onUndo}
          />
        </ModBox>
      </ModBox>
      <ModBox>
        <ModBox mt={16} show={type === 'director'}>
          <Form
            ref={dirRef}
            formData={DirectorForm(
              <Icon id={'CALENDAR'} size={15} color="PRIMARY" />,
              itemData,
              true,
              false,
              isBeginSet,
              isEditPressed,
              beginDate,
            )}
            actionButtons={handleDirectorActions}
            container={FormBoxFull}
            initialValues={{
              din: itemData?.din,
              firstName: itemData?.firstName,
              middleName: itemData?.middleName,
              lastName: itemData?.lastName,
              dob: itemData?.dob,
              beginAt: itemData?.beginAt,
              endAt: itemData?.endAt,
              directorReferenceId: itemData?.directorReferenceId,
              action: itemData?.action,
              dummyPlaceHolder: '',
            }}
          />
        </ModBox>
        <ModBox mt={16} show={type === 'ubo'}>
          <Form
            ref={uboRef}
            formData={UboForm(<Icon id={'CALENDAR'} size={15} color="PRIMARY" />, itemData, true, false)}
            actionButtons={handleUboActions}
            container={FormBoxFull}
            initialValues={{
              uboFname: itemData?.firstName,
              uboMname: itemData?.middleName,
              uboLname: itemData?.lastName,
              uboDob: itemData?.dob,
              action: itemData?.action,
              beneficialOwnerReferenceId: itemData?.beneficialOwnerReferenceId,
            }}
          />
        </ModBox>
        <ModBox mt={16} show={type === 'auth'}>
          <Form
            ref={authRef}
            formData={AuthorisedForm(<Icon id={'CALENDAR'} size={15} color="PRIMARY" />, itemData, true)}
            actionButtons={handleAuthActions}
            container={FormBoxFull}
            initialValues={{
              authSigFirstname: itemData?.firstName,
              authSigMidname: itemData?.middleName,
              authSigLastname: itemData?.lastName,
              authSigDOB: itemData?.dob,
              action: itemData?.action,
              authorisedSignatoryReferenceId: itemData?.authorisedSignatoryReferenceId,
            }}
          />
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

export { TableWithEditAddForm }
